/**
 * GlowItSkincare front-end JS
 */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('primary-nav');
  var backdrop = document.querySelector('.nav-backdrop');

  function setNavOpen(open) {
    if (!nav || !toggle) return;
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('nav-open', open);
    if (backdrop) {
      backdrop.hidden = !open;
    }
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      setNavOpen(!nav.classList.contains('is-open'));
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setNavOpen(false);
      });
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      setNavOpen(false);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setNavOpen(false);
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 900) {
      setNavOpen(false);
    }
  });

  var topBtn = document.getElementById('glowit-top');
  if (topBtn) {
    var syncTopBtn = function () {
      topBtn.classList.toggle('is-visible', window.scrollY > 420);
    };
    window.addEventListener('scroll', syncTopBtn, { passive: true });
    syncTopBtn();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  var header = document.getElementById('masthead');
  if (header) {
    var onScroll = function () {
      header.style.boxShadow = window.scrollY > 20 ? '0 8px 24px rgba(0,0,0,.06)' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Hero Azadi slider
  var hero = document.querySelector('[data-hero-slider]');
  if (hero) {
    var hSlides = hero.querySelectorAll('[data-hero-slide]');
    var hDots = hero.querySelectorAll('[data-hero-dot]');
    var hIndex = 0;
    var hTimer = null;
    var showHero = function (i) {
      if (!hSlides.length) return;
      hIndex = (i + hSlides.length) % hSlides.length;
      hSlides.forEach(function (slide, n) {
        var on = n === hIndex;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) slide.removeAttribute('tabindex');
        else slide.setAttribute('tabindex', '-1');
      });
      hDots.forEach(function (dot, n) {
        var on = n === hIndex;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };
    var restartHero = function () {
      if (hTimer) clearInterval(hTimer);
      hTimer = setInterval(function () { showHero(hIndex + 1); }, 5000);
    };
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showHero(hIndex - 1); restartHero(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showHero(hIndex + 1); restartHero(); });
    hDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showHero(parseInt(dot.getAttribute('data-hero-dot'), 10) || 0);
        restartHero();
      });
    });
    restartHero();
  }

  var popup = document.getElementById('glowit-popup');
  if (popup) {
    var closed = sessionStorage.getItem('glowit_popup_closed');
    if (!closed) {
      setTimeout(function () {
        popup.hidden = false;
      }, 2500);
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.hidden = true;
        sessionStorage.setItem('glowit_popup_closed', '1');
      });
    });

    var form = document.getElementById('glowit-subscribe-form');
    var msg = document.getElementById('glowit-subscribe-msg');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = document.getElementById('glowit-subscribe-email');
        var email = emailInput ? emailInput.value.trim() : '';
        var btn = form.querySelector('button[type="submit"]');
        if (!email || !window.glowitData || !glowitData.ajaxUrl) return;

        if (btn) {
          btn.disabled = true;
          btn.textContent = '...';
        }
        if (msg) {
          msg.hidden = true;
          msg.classList.remove('is-error', 'is-ok');
        }

        var body = new FormData();
        body.append('action', 'glowit_subscribe');
        body.append('nonce', glowitData.subscribeNonce || '');
        body.append('email', email);

        fetch(glowitData.ajaxUrl, { method: 'POST', body: body, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var text = (res && res.data && res.data.message) ? res.data.message : (res && res.success ? glowitData.subscribeOk : glowitData.subscribeErr);
            if (msg) {
              msg.textContent = text;
              msg.hidden = false;
              msg.classList.add(res && res.success ? 'is-ok' : 'is-error');
            }
            if (res && res.success) {
              if (res.data && res.data.email) {
                try {
                  var maxAge = 90 * 24 * 60 * 60;
                  document.cookie = 'glowit_sub_email=' + encodeURIComponent(res.data.email) + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
                } catch (err) { /* ignore */ }
              }
              form.reset();
              setTimeout(function () {
                popup.hidden = true;
                sessionStorage.setItem('glowit_popup_closed', '1');
              }, 1600);
            }
          })
          .catch(function () {
            if (msg) {
              msg.textContent = glowitData.subscribeErr || 'Error';
              msg.hidden = false;
              msg.classList.add('is-error');
            }
          })
          .finally(function () {
            if (btn) {
              btn.disabled = false;
              btn.textContent = 'SUBMIT';
            }
          });
      });
    }
  }

  // Testimonials slider
  var slider = document.querySelector('[data-testimonial-slider]');
  if (slider) {
    var track = slider.querySelector('.testimonial-slider__track');
    var slides = slider.querySelectorAll('.testimonial-slide');
    var index = 0;
    var go = function (i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
    };
    var prev = slider.querySelector('.ts-prev');
    var next = slider.querySelector('.ts-next');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    setInterval(function () { go(index + 1); }, 7000);
  }

  // Beauty category image slider
  var beauty = document.querySelector('[data-beauty-slider]');
  if (beauty) {
    var bTrack = beauty.querySelector('.beauty-slider__track');
    var bSlides = beauty.querySelectorAll('.beauty-slide');
    var bIndex = 0;
    var bGo = function (i) {
      if (!bSlides.length) return;
      bIndex = (i + bSlides.length) % bSlides.length;
      bTrack.style.transform = 'translateX(' + (-bIndex * 100) + '%)';
    };
    var bPrev = beauty.querySelector('.bs-prev');
    var bNext = beauty.querySelector('.bs-next');
    if (bPrev) bPrev.addEventListener('click', function () { bGo(bIndex - 1); });
    if (bNext) bNext.addEventListener('click', function () { bGo(bIndex + 1); });
    setInterval(function () { bGo(bIndex + 1); }, 5500);
  }

  // Before / After compare slider
  var ba = document.querySelector('[data-ba-compare]');
  if (ba) {
    var wrap = ba.querySelector('.ba-compare__before-wrap');
    var handle = ba.querySelector('.ba-compare__handle');
    var range = ba.querySelector('.ba-compare__range');
    var setPos = function (val) {
      var v = Math.max(0, Math.min(100, Number(val)));
      if (wrap) wrap.style.width = v + '%';
      if (handle) handle.style.left = v + '%';
      // Keep before image full-bleed width of media
      var media = ba.querySelector('.ba-compare__media');
      var beforeImg = ba.querySelector('.ba-compare__before');
      if (media && beforeImg) {
        beforeImg.style.width = media.offsetWidth + 'px';
      }
    };
    if (range) {
      range.addEventListener('input', function () { setPos(range.value); });
      setPos(range.value);
    }
    window.addEventListener('resize', function () { setPos(range ? range.value : 50); }, { passive: true });
  }

  var revealEls = document.querySelectorAll('.section, .cat-tile, .home-beauty, .glowit-product-card, .home-results__banner-inner, .ba-compare');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  // Checkout: subscriber discount refresh + required-field asterisks (block checkout).
  if (document.body.classList.contains('woocommerce-checkout') || document.querySelector('.wc-block-checkout')) {
    var emailField = document.getElementById('billing_email') || document.getElementById('email');
    if (emailField) {
      var triggerCheckoutUpdate = function () {
        if (window.jQuery) {
          jQuery(document.body).trigger('update_checkout');
        }
      };
      emailField.addEventListener('change', triggerCheckoutUpdate);
      emailField.addEventListener('blur', triggerCheckoutUpdate);
    }

    // Block checkout: mark required fields so CSS can show "*".
    var markRequiredCheckoutFields = function () {
      var root = document.querySelector('.wc-block-checkout');
      if (!root) return;
      root.querySelectorAll('.is-required-field').forEach(function (el) {
        el.classList.remove('is-required-field');
      });
      root.querySelectorAll('[aria-required="true"], [required]').forEach(function (input) {
        var wrap = input.closest(
          '.wc-block-components-text-input, .wc-block-components-combobox, .wc-block-components-select, .wc-block-components-country-input, .wc-block-components-state-input'
        );
        if (wrap) wrap.classList.add('is-required-field');
      });
    };
    markRequiredCheckoutFields();
    if ('MutationObserver' in window) {
      var moTimer = null;
      var mo = new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(markRequiredCheckoutFields, 150);
      });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-required', 'required'] });
    }
  }
})();
